module.exports = __webpack_public_path__ + "static/media/NotoSans-Medium.293e6bd5.woff2";